import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PaymentInstrumentDataPropsAndroid from './../../../common/paymentInstrumentDataProps.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Data associated to the payment instrument. You can use this information to display the vaulted payment method in your UI.`}</p>
    <PaymentInstrumentDataPropsAndroid mdxType="PaymentInstrumentDataPropsAndroid" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      